export const PLACE = 'Attendees Bulk Import';
export const TOOL_NAME = 'Bulk Import Attendees';
export const TOOL_PROGRESS_LABEL = 'Bulk attendees importing progress...';

export const STICKY_HEADER_OFFSET = 105;

export enum BULK_IMPORT_USERS_STEPS {
    UPLOAD_FILE = 0,
    VALIDATE_FILE = 1,
    CREATION_RESULT = 2,
}

export const STEP_TITLE = {
    [BULK_IMPORT_USERS_STEPS.UPLOAD_FILE]: 'Upload file',
    [BULK_IMPORT_USERS_STEPS.VALIDATE_FILE]: 'Validate file',
    [BULK_IMPORT_USERS_STEPS.CREATION_RESULT]: 'Bulk Import Result',
};

export const FILE_NAME = 'Add-attendees-report';
export const FILE_HEADERS = {
    userId: 'User ID',
    email: 'Email',
    firstName: 'First Name',
    lastName: 'Last Name',
    userType: 'User Type',
    userStatus: 'User Status',
    conferenceAccountId: 'Conference Account ID',
    conferenceAccountName: 'Conference Account Name',
    primaryAccountId: 'Primary Account ID',
    primaryAccountName: 'Primary Account Name',
    country: 'Country',
    jobTitle: 'Job Title',
    city: 'City',
    notes: 'Notes',
    actionStatus: 'Action Status',
    jobInfo: 'Action Details',
};
